var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock1Year(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9002 23.5995C10.9002 23.7995 3.60023 26.5995 3.70023 29.8995C3.80023 33.1995 11.2002 35.5995 20.2002 35.3995C29.2002 35.1995 36.5002 32.3995 36.4002 29.0995C36.3002 25.7995 28.9002 23.3995 19.9002 23.5995Z",
    fill: "url(#paint0_linear_641_5808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1453 35.3977C29.2 35.1764 36.4758 32.3563 36.3962 29.0988C36.3166 25.8413 28.9117 23.38 19.857 23.6013C10.8022 23.8226 3.52645 26.6427 3.60606 29.9002C3.68568 33.1577 11.0905 35.619 20.1453 35.3977Z",
    stroke: "url(#paint1_linear_641_5808)",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 26.8999C26.3996 26.6999 31.7996 28.4999 31.7996 30.8999C31.8996 33.1999 26.5996 35.2999 20.0996 35.3999C13.5996 35.4999 8.19963 33.7999 8.19963 31.3999C8.09963 29.0999 13.3996 26.9999 19.8996 26.8999Z",
    fill: "url(#paint2_linear_641_5808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1023 35.3006C26.6173 35.1414 31.8528 33.1324 31.7961 30.8135C31.7394 28.4946 26.4121 26.7439 19.897 26.9031C13.382 27.0623 8.14653 29.0712 8.2032 31.3901C8.25987 33.709 13.5873 35.4598 20.1023 35.3006Z",
    stroke: "url(#paint3_linear_641_5808)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5V35.3",
    stroke: "url(#paint4_linear_641_5808)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9996 5.59961L20.0996 35.2996",
    stroke: "url(#paint5_linear_641_5808)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.59961L20.1 35.2996",
    stroke: "url(#paint6_linear_641_5808)",
    strokeWidth: 0.19,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5004 18.1004C37.0409 18.1004 39.1004 16.0409 39.1004 13.5004C39.1004 10.9599 37.0409 8.90039 34.5004 8.90039C31.9599 8.90039 29.9004 10.9599 29.9004 13.5004C29.9004 16.0409 31.9599 18.1004 34.5004 18.1004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5004 18.1004C37.0409 18.1004 39.1004 16.0409 39.1004 13.5004C39.1004 10.9599 37.0409 8.90039 34.5004 8.90039C31.9599 8.90039 29.9004 10.9599 29.9004 13.5004C29.9004 16.0409 31.9599 18.1004 34.5004 18.1004Z",
    stroke: "url(#paint7_linear_641_5808)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4998 17.2008C36.5433 17.2008 38.1998 15.5442 38.1998 13.5008C38.1998 11.4573 36.5433 9.80078 34.4998 9.80078C32.4564 9.80078 30.7998 11.4573 30.7998 13.5008C30.7998 15.5442 32.4564 17.2008 34.4998 17.2008Z",
    stroke: "url(#paint8_linear_641_5808)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4998 17.2008C36.5433 17.2008 38.1998 15.5442 38.1998 13.5008C38.1998 11.4573 36.5433 9.80078 34.4998 9.80078C32.4564 9.80078 30.7998 11.4573 30.7998 13.5008C30.7998 15.5442 32.4564 17.2008 34.4998 17.2008Z",
    fill: "url(#paint9_linear_641_5808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 19.6004C8.64051 19.6004 10.7 17.5409 10.7 15.0004C10.7 12.4599 8.64051 10.4004 6.1 10.4004C3.55949 10.4004 1.5 12.4599 1.5 15.0004C1.5 17.5409 3.55949 19.6004 6.1 19.6004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 19.6004C8.64051 19.6004 10.7 17.5409 10.7 15.0004C10.7 12.4599 8.64051 10.4004 6.1 10.4004C3.55949 10.4004 1.5 12.4599 1.5 15.0004C1.5 17.5409 3.55949 19.6004 6.1 19.6004Z",
    stroke: "url(#paint10_linear_641_5808)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10039 18.7008C8.14384 18.7008 9.80039 17.0442 9.80039 15.0008C9.80039 12.9573 8.14384 11.3008 6.10039 11.3008C4.05694 11.3008 2.40039 12.9573 2.40039 15.0008C2.40039 17.0442 4.05694 18.7008 6.10039 18.7008Z",
    stroke: "url(#paint11_linear_641_5808)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10039 18.7008C8.14384 18.7008 9.80039 17.0442 9.80039 15.0008C9.80039 12.9573 8.14384 11.3008 6.10039 11.3008C4.05694 11.3008 2.40039 12.9573 2.40039 15.0008C2.40039 17.0442 4.05694 18.7008 6.10039 18.7008Z",
    fill: "url(#paint12_linear_641_5808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 26.2996C22.5409 26.2996 24.6004 24.2401 24.6004 21.6996C24.6004 19.1591 22.5409 17.0996 20.0004 17.0996C17.4599 17.0996 15.4004 19.1591 15.4004 21.6996C15.4004 24.2401 17.4599 26.2996 20.0004 26.2996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 26.2996C22.5409 26.2996 24.6004 24.2401 24.6004 21.6996C24.6004 19.1591 22.5409 17.0996 20.0004 17.0996C17.4599 17.0996 15.4004 19.1591 15.4004 21.6996C15.4004 24.2401 17.4599 26.2996 20.0004 26.2996Z",
    stroke: "url(#paint13_linear_641_5808)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 25.4C22.0433 25.4 23.6998 23.7435 23.6998 21.7C23.6998 19.6565 22.0433 18 19.9998 18C17.9564 18 16.2998 19.6565 16.2998 21.7C16.2998 23.7435 17.9564 25.4 19.9998 25.4Z",
    stroke: "url(#paint14_linear_641_5808)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 25.4C22.0433 25.4 23.6998 23.7435 23.6998 21.7C23.6998 19.6565 22.0433 18 19.9998 18C17.9564 18 16.2998 19.6565 16.2998 21.7C16.2998 23.7435 17.9564 25.4 19.9998 25.4Z",
    fill: "url(#paint15_linear_641_5808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 12.3992C22.5409 12.3992 24.6004 10.3397 24.6004 7.79922C24.6004 5.25871 22.5409 3.19922 20.0004 3.19922C17.4599 3.19922 15.4004 5.25871 15.4004 7.79922C15.4004 10.3397 17.4599 12.3992 20.0004 12.3992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 12.3992C22.5409 12.3992 24.6004 10.3397 24.6004 7.79922C24.6004 5.25871 22.5409 3.19922 20.0004 3.19922C17.4599 3.19922 15.4004 5.25871 15.4004 7.79922C15.4004 10.3397 17.4599 12.3992 20.0004 12.3992Z",
    stroke: "url(#paint16_linear_641_5808)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 11.4996C22.0433 11.4996 23.6998 9.84306 23.6998 7.79961C23.6998 5.75616 22.0433 4.09961 19.9998 4.09961C17.9564 4.09961 16.2998 5.75616 16.2998 7.79961C16.2998 9.84306 17.9564 11.4996 19.9998 11.4996Z",
    stroke: "url(#paint17_linear_641_5808)",
    strokeWidth: 0.04,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 11.4996C22.0433 11.4996 23.6998 9.84306 23.6998 7.79961C23.6998 5.75616 22.0433 4.09961 19.9998 4.09961C17.9564 4.09961 16.2998 5.75616 16.2998 7.79961C16.2998 9.84306 17.9564 11.4996 19.9998 11.4996Z",
    fill: "url(#paint18_linear_641_5808)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_5808",
    x1: 20.0002,
    y1: 28.3199,
    x2: 20.0002,
    y2: 39.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8811,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_641_5808",
    x1: 19.69,
    y1: 23.3109,
    x2: 20.2923,
    y2: 35.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_641_5808",
    x1: 20.0017,
    y1: 29.88,
    x2: 20.0017,
    y2: 38.3898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_641_5808",
    x1: 19.8194,
    y1: 26.7886,
    x2: 20.2434,
    y2: 35.4582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C2460C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#953609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6D2707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4B1B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#301103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#1B0A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C0401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#030100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_641_5808",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_641_5808",
    x1: 30.0694,
    y1: 5.58701,
    x2: 30.0694,
    y2: 35.4024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_641_5808",
    x1: 10.0698,
    y1: 5.58651,
    x2: 10.0698,
    y2: 35.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CA490C",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7C2D07",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_641_5808",
    x1: 38.3935,
    y1: 9.82264,
    x2: 30.5571,
    y2: 15.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_641_5808",
    x1: 39.3856,
    y1: 14.0099,
    x2: 31.9558,
    y2: 12.8423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_641_5808",
    x1: 33.2895,
    y1: 13.6741,
    x2: 30.8077,
    y2: 15.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_641_5808",
    x1: 4.86411,
    y1: 10.4122,
    x2: 7.5457,
    y2: 19.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_641_5808",
    x1: 7.79028,
    y1: 12.0922,
    x2: 4.1433,
    y2: 18.6712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_641_5808",
    x1: 6.76427,
    y1: 16.4673,
    x2: 8.03131,
    y2: 19.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_641_5808",
    x1: 19.4622,
    y1: 26.794,
    x2: 20.7293,
    y2: 17.1769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_641_5808",
    x1: 17.3073,
    y1: 23.7623,
    x2: 23.271,
    y2: 19.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_641_5808",
    x1: 20.1299,
    y1: 20.4966,
    x2: 20.2075,
    y2: 17.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_641_5808",
    x1: 19.4639,
    y1: 12.8939,
    x2: 20.7281,
    y2: 3.27644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_641_5808",
    x1: 17.3121,
    y1: 9.85277,
    x2: 23.2813,
    y2: 5.27817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_641_5808",
    x1: 20.1317,
    y1: 6.60428,
    x2: 20.2138,
    y2: 3.24267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1Year);
export default __webpack_public_path__ + "static/media/lock-1-year.1ab4834b1d30cdd663e93bc932826879.svg";
export { ForwardRef as ReactComponent };